import * as types from './types';

import { NotificationMessage } from '../../../components/messages/ApiResultMessage';

export const getUserSetup = showInactive => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.getGeneric('Usermaster')
      .then(response => {
        dispatch({
          type: types.USERSETUP_GET,
          payload: response,
        });
        dispatch({
          type: types.USERSETUP_SET_FILTERED_DATA,
          payload: showInactive,
        });
      })
      .catch(err => {
        console.log(err); //TODO: dispatch ERROR action
      });
  };
};

export const checkAll = (checkAll, currentRows) => {
  return {
    type: types.USERSETUP_CHECKALL_ASSIGN_SITE_DATA,
    payload: { checkAll, currentRows },
  };
};

export const setAssignCurrentUser = userId => {
  return {
    type: types.USERSETUP_SET_ASSIGN_CURRENT_USER,
    payload: userId,
  };
};

export const clearAssignSiteData = () => {
  return {
    type: types.USERSETUP_CLEAR_ASSIGN_SITE_DATA,
  };
};

export const updateAssignSiteData = item => {
  return {
    type: types.USERSETUP_UPDATE_ASSIGN_SITE_DATA,
    payload: item,
  };
};

export const getSitesHaveAccess = userId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch({
        type: types.USERSETUP_SET_ASSIGN_GRIDLOADING,
        payload: true,
      });
      const siteResponse = await MPWWebApi.postGenericInsertUpdate(
        'Sitemaster/AccessibleSites',
        userId
      );
      dispatch({
        type: types.USERSETUP_SET_ASSIGN_SITE_DATA,
        payload: siteResponse,
      });
    } catch (ex) {
      console.log(ex);
    }

    dispatch({
      type: types.USERSETUP_SET_ASSIGN_GRIDLOADING,
      payload: false,
    });
  };
};

export const postSitesHaveAccess = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch({
        type: types.USERSETUP_SET_ASSIGN_GRIDLOADING,
        payload: true,
      });
      const assignResponse = await MPWWebApi.postGenericInsertUpdate(
        'usersitebyprod/assignsites',
        data
      );
      NotificationMessage(
        assignResponse,
        undefined,
        undefined,
        'The user has been assigned to the selected site(s).'
      );
    } catch (ex) {
      NotificationMessage(ex.response);
    }

    dispatch({
      type: types.USERSETUP_SET_ASSIGN_GRIDLOADING,
      payload: false,
    });
  };
};

export const getRoles = () => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.getGeneric('Role')
      .then(response => {
        dispatch({
          type: types.USERSETUP_GET_ROLES,
          payload: response,
        });
      })
      .catch(err => {
        console.log(err); //TODO: dispatch ERROR action
      });
  };
};

export const postDeleteUser = Id => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.USERSETUP_BEGIN_SUBMIT,
    });
    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericDelete('Usermaster', Id)
        .then(response => {
          dispatch({
            type: types.USERSETUP_POST,
            payload: response,
          });

          dispatch({
            type: types.USERSETUP_END_SUBMIT,
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: types.USERSETUP_HAD_ERROR,
            payload: err.response.data.Errors,
          });
          reject(err.response.data.Errors);
        });
    });
  };
};

export const postResetPassword = values => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.USERSETUP_BEGIN_SUBMIT,
    });
    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericInsertUpdate('account/resetpassword', values)
        .then(response => {
          dispatch({
            type: types.USERSETUP_POST,
            payload: response,
          });

          dispatch({
            type: types.USERSETUP_END_SUBMIT,
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: types.USERSETUP_HAD_ERROR,
            payload: err.response.data.Errors,
          });
          reject(err.response.data.Errors);
        });
    });
  };
};

export const postUsermaster = values => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.USERSETUP_BEGIN_SUBMIT,
    });
    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericInsertUpdate('Usermaster', values)
        .then(response => {
          dispatch({
            type: types.USERSETUP_POST,
            payload: response,
          });

          dispatch({
            type: types.USERSETUP_END_SUBMIT,
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: types.USERSETUP_HAD_ERROR,
            payload: err.response.data.Errors,
          });
          console.log(err.response);
          reject(err.response.data.Errors);
        });
    });
  };
};

export const setShowInactive = value => {
  return {
    type: types.USERSETUP_SET_SHOW_INACTIVE,
    payload: value,
  };
};

export const setFilteredData = value => {
  return {
    type: types.USERSETUP_SET_FILTERED_DATA,
    payload: value,
  };
};

export const clearErrors = () => {
  return {
    type: types.USERSETUP_CLEAR_ERRORS,
  };
};
export const updateIsPageAccessible = (currentRows, fieldName, id, index) => {
  return {
    type: types.USERSETUP_UPDATE_IS_PAGE_ACCESSIBLE,
    payload: { currentRows, fieldName, id, index },
  };
};



// WEBPACK FOOTER //
// ./src/pages/usersetup/state/actions.js